<div class="mb-4 flex flex-col">
  <div class="flex items-center justify-between">
    <h3 class="text-neutral-500">Візит, до якого прив'язуємо</h3>
    @if (!loading()) {
      <button
        class="btn btn-secondary text-sm"
        (click)="getEleksVisitsData(userId())"
      >
        Оновити
      </button>
    }
  </div>
</div>

@if (!loading()) {
  <div class="mb-4 flex items-center justify-between">
    @if (eleksVisits().length > 1) {
      <span class="flex flex-col">
        <span class="text-md text-gray-2"> Оберіть візит, з яким буде здійснена синхронізація </span>
        <span class="text-md text-gray-2"> Знайдено візитів: {{ eleksVisits().length }}. </span>
      </span>
    }
  </div>

  <div class="max-h-[22rem] overflow-y-auto overflow-x-hidden">
    @for (visit of eleksVisits(); track visit) {
      <div
        class="mb-6"
        [ngClass]="{ 'mr-2': eleksVisits().length > 3 }"
      >
        <hm-eleks-visit [eleksVisitData]="visit"></hm-eleks-visit>
      </div>
    }

    @if (eleksVisitsWarning()) {
      <div class="mb-2 flex items-center gap-10 rounded-2xl bg-[#FFF5ED] px-12 py-10">
        <img
          priority="true"
          alt="Warning"
          width="36"
          height="40"
          [ngSrc]="'/assets/icons/ic_warning_fire.svg'"
        />
        <span>{{ eleksVisitsWarning() }}</span>
      </div>
    }
  </div>
} @else {
  <div class="my-2 flex items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
